import React from 'react';

const Skeleton = () => (
    <div className="skeleton">
        <div className="skeleton__avatar"></div>
        <div className="skeleton__author"></div>
        <div className="skeleton__details"></div>
    </div>
)

export default Skeleton;


// WEBPACK FOOTER //
// ./src/components/Messages/Skeleton.js